export const HEADER_TESTID = 'header';
export const HEADER_DEMANDANALYSISTAB_TESTID = 'Demand Analysis';
export const HEADER_OVERRIDEMANAGERTAB_TESTID = 'Override Manager';
